import { defineMessages } from 'react-intl';

export default defineMessages({
  stepDisplay: {
    id: 'booking.stepDisplay',
    defaultMessage: '{step} of 3',
  },
});
